<div class="flex flex-wrap items-center justify-center gap-2.5 p-4">
  <div class="flex items-center justify-between gap-2.5 sm:justify-around">
    <button (click)="onPeriodClicked(7)" [class.selected]="chartPeriod() === 7" class="variable-chart-selector-button" mat-raised-button>
      1 {{ 'I18N_CHART.WEEK' | translate }}
    </button>
    <button
      (click)="onPeriodClicked(defaultChartPeriod())"
      [class.selected]="chartPeriod() === defaultChartPeriod()"
      class="variable-chart-selector-button"
      mat-raised-button
    >
      2 {{ 'I18N_CHART.WEEKS' | translate }}
    </button>
    <button (click)="onPeriodClicked(30)" [class.selected]="chartPeriod() === 30" class="variable-chart-selector-button" mat-raised-button>
      1 {{ 'I18N_CHART.MONTH' | translate }}
    </button>
  </div>
  <div class="variable-chart-dates-filter flex items-center justify-between gap-2.5 sm:justify-around">
    <div class="variable-chart-datepicker mr-2 flex w-35 pl-2" style="background-color: var(--light-grey)">
      <input
        [formControl]="startDateControl"
        class="min-w-0! outline-0!"
        #startDate
        [matDatepicker]="startPicker"
        matInput
        [min]="minStartDate()"
        [max]="maxStartDate()"
        (dateChange)="onStartDateChange($safeNavigationMigration($event?.value))"
        placeholder="{{ 'I18N_CHART.FROM' | translate }}"
      />
      <mat-datepicker-toggle [for]="startPicker" matTextSuffix />
      <mat-datepicker #startPicker />
    </div>
    <div class="variable-chart-datepicker flex w-35 pl-2" style="background-color: var(--light-grey)">
      <input
        [formControl]="endDateControl"
        class="min-w-0! outline-0!"
        #endDate
        [matDatepicker]="endPicker"
        matInput
        [min]="minEndDate()"
        [max]="maxEndDate()"
        placeholder="{{ 'I18N_CHART.TO' | translate }}"
        (dateChange)="onEndDateChange($safeNavigationMigration($event?.value))"
      />
      <mat-datepicker-toggle [for]="endPicker" matTextSuffix />
      <mat-datepicker #endPicker />
    </div>
  </div>
  <button
    (click)="apply()"
    [class.selected]="chartPeriod() === 0"
    [disabled]="!selectedStartDate() || !selectedEndDate()"
    class="variable-chart-selector-button"
    mat-raised-button
  >
    {{ 'I18N_CHART.APPLY' | translate | uppercase }}
  </button>
</div>
